import { createSelector } from "reselect"
import { get } from "lodash"
import { getCurrent, getFirst } from "./risk"
import { getDisplayCategories } from "./data"
import { getModelCategories } from "selectors/modelMetadata"

export const getOptions = createSelector(
  [getModelCategories, getFirst, getCurrent, getDisplayCategories],
  (categories, first, current, displayCategories) => {
    if (first && current) {
      const options = [{
        id: "total",
        color: "#00abe8",
        label: "Total",
        value: current.total,
        firstValue: first.total,
        delta: (current.total - first.total),
      }, {
        id: "factors",
        color: "#9067a7",
        label: "Factors",
        value: current.factorsTotal,
        firstValue: first.factorsTotal,
        delta: (current.factorsTotal - first.factorsTotal),
      },
      ...categories
        .filter(category => !category.singleFactor)
        .map(category => {
          if (!displayCategories[category.id]) return null

          const field = `categories.${category.id}`
          const value = get(current, field)
          const firstValue = get(first, field)
          const delta = value - firstValue

          return { value, delta, firstValue, ...category }
        }),
      ]

      // filter out options for which there's no value
      return options.filter(option => option && !Number.isNaN(option.value))
    } else {
      return []
    }
  },
)
